import React from 'react'
import classnames from 'classnames'
import styles from './InputCaptcha.less'
import ReCAPTCHA from "react-google-recaptcha"
import { CAPTCHA_SITE_KEY } from "../../constants/config"

class InputCaptcha extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    const { formType = 'normal' } = this.props

    this.setState({
      loading: false
    }, () => {
      if (this.inputCaptcha) {
        this.inputCaptcha.reset();

        if (formType === "invisible") {
          this.inputCaptcha.execute();
        }
      }
    })
  }

  _onChange = (value) => {
    const { onChange = () => { } } = this.props

    onChange(value)
  }

  _getThisInput = () => {
    const { getThisInput = () => { } } = this.props
    getThisInput(this)
  }

  resetRecaptcha = () => {
    const { formType = 'normal' } = this.props

    if (this.inputCaptcha) {
      this.inputCaptcha.reset();

      if (formType === "invisible") {
        this.inputCaptcha.execute();
      }
    }
  }

  render() {
    const {
      name = '',
      sitekey = CAPTCHA_SITE_KEY,
      label = '',
      styleName = 'light',
      formType = 'normal',
      required = false,
      message = '',
      isValid = true
    } = this.props
    const { loading } = this.state

    if (loading) return null

    return (
      <div
        getthisinput={this._getThisInput()}
        data-test="input-captcha"
        className={classnames({
          [styles.InputCaptcha]: true
        })}>
        <ReCAPTCHA
          onChange={this._onChange}
          onExpired={this.resetRecaptcha}
          ref={(el) => { this.inputCaptcha = el; }}
          size={formType}
          theme={styleName}
          render="explicit"
          sitekey={sitekey} />
        {
          formType !== "invisible" &&
          <div className={classnames({
            [styles.message]: true,
            [styles.messageShow]: !isValid,
          })}>
            {message}
          </div>
        }
      </div>
    )
  }
}

export default InputCaptcha



// WEBPACK FOOTER //
// ./src/AtomicComponents/InputCaptcha/InputCaptcha.jsx